import type { ReactNode } from "react";
import "./Pill.css";

type Tone = "neutral" | "ok" | "warn" | "err" | "quiet";

interface PillProps {
  tone?: Tone;
  children: ReactNode;
}

export function Pill({ tone = "neutral", children }: PillProps) {
  return <span className={`pill pill--${tone}`}>{children}</span>;
}
